import React from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';

import type { InputProps } from './types';

export default function ZipInput({ country, options, value, onChange }: InputProps) {
  if (!country.hasZip || options.zip?.show === false) {
    return null;
  }

  return (
    <ManagedFormGroup
      hasError={options.zip?.hasError}
      label={country.zipLabel}
      required={options.zip?.required !== false}
      value={value.zip}
      onValueChange={zip => onChange({ ...value, zip })}
    />
  );
}
